import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CommonService } from 'src/app/Service/Common.service';
import { Module } from 'src/app/Service/element-details.data.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { IProjectElementDetailsOutput, IProjectElementsOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { ScheduleDefinitionService } from 'src/app/Service/scheduledefintion/scheduledefintion.service';
import { IDocSetModel } from 'src/app/ViewModel/ScheduleDefinitionModel';
import { DynamicFormComponent } from '../dynamic-form/components/dynamic-form/dynamic-form.component';
import { FieldConfig } from '../dynamic-form/interface/field.interface';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-dci-filter',
  templateUrl: './dci-filter.component.html',
  styleUrls: ['./dci-filter.component.css']
})
export class DciFilterComponent implements OnInit, AfterContentInit {

  docIndex: number = 0;
  public projectId!: number;
  public groupId!: number;
  public memberId!: number;
  public stageList: any[] = [];
  public dwgList!: any[];
  public discipline!: any[];
  public structure!: any[];
  public enableFilter = false;
  public memberLinkedGroupID!: number;
  public from_Date: string | null = null;
  public to_Date: string | null = null;
  public stages: number | null = null;
  public disciplineId: string | null = null;
  public structureId: string | null = null;
  public drg_Type: string | null = null;
  public fromDate: any;
  public requiredField!: any;
  public ToMinDate!: Date;
  public Doc_typeid!: any | null;
  public Doc_type: any[] = [
    { value: '1', viewValue: 'DCI' },
    { value: '2', viewValue: 'Ext DCI' },
    { value: '3', viewValue: 'Std DCI' },
    { value: '4', viewValue: 'Vendor DCI' },
  ];
  public transmittal_no: string | null = null;
  public projectElements: IProjectElementsOutput[] = [];
  DCI_Type!: FormGroup;
  docSetList: IDocSetModel[] = [];
  public docset_id: number | null = null;
  public doc_no!: string;
  @Output() valueChange = new EventEmitter();
  @Input() inputFields!: string;

  @ViewChild("docSetForm") dynamicForm: DynamicFormComponent;
  elementsConfig: FieldConfig[] = [];

  constructor(private _projInfoService: ProjectInfoService, private _formBuilder: FormBuilder,
    private _commonService: CommonService, private _scheDefService: ScheduleDefinitionService) { }

  ngOnInit() {
    this.projectId = this._commonService.getProjectId();
    this.groupId = this._commonService.getLoggedInUserGroupId();
    this.memberId = this._commonService.getLoggedInUserId();
    this.getDropDownValue();
    this.setDCIType_form();
    this._commonService.getProjectMemberLinkGroupDetails(this.projectId, this.memberId).subscribe(data => {
      this.memberLinkedGroupID = data[0].groupId;
    })
    this.getDynamicForm();
  }

  ngAfterContentInit() {
    switch (this.inputFields) {
      case 'final_drawing':
        this.requiredField = {
          "discipline": true,
          "structure": true,
          "dwg_doc": true,
          "workflow_Status": true,
          "doc_dci_type": true,
          "fromtodate": true,
          "transmittal_no": false,
          "document_Set": false,
          "btn-stylee-required": true,
          "doc_no": false
        }
        break;
      case 'pending_drawing_status':
        this.requiredField = {
          "discipline": true,
          "structure": true,
          "dwg_doc": true,
          "workflow_Status": true,
          "doc_dci_type": true,
          "fromtodate": true,
          "transmittal_no": false,
          "document_Set": false,
          "btn-stylee-required": true,
          "doc_no": false
        }
        break;
      case 'respond_workflow':
        this.requiredField = {
          "discipline": true,
          "structure": true,
          "dwg_doc": true,
          "workflow_Status": true,
          "fromtodate": true,
          "doc_dci_type": true,
          "doc_no": false
        }
        break;
      case 'search_dci':
        this.requiredField = {
          "discipline": true,
          "structure": true,
          "dwg_doc": true,
          "workflow_Status": true,
          "doc_dci_type": true,
          "fromtodate": true,
          "transmittal_no": true,
          "document_Set": true,
          "btn-stylee-required": true,
          "doc_no": true
        }

        break;
    }
  }

  setDCIType_form() {
    this.DCI_Type = this._formBuilder.group({
      dci_dwg: new FormControl(false),
      ext_dci: new FormControl(false),
      std_drawing: new FormControl(false),
      ven_dwg: new FormControl(false),
    })
  }

  getDropDownValue() {
    this._projInfoService.getProjectElementDetails({
      projectId: this.projectId,
      groupId: this.groupId,
      moduleId: Module.ScheduleDocument,
      deDescription: 'Workflow Status'
    }).subscribe((res: IProjectElementDetailsOutput[]) => {
      res.forEach(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);
      this.stageList = res;
    });

    this._projInfoService.getProjectElementDetails({
      projectId: this.projectId,
      groupId: this.groupId,
      moduleId: Module.ScheduleDocument,
      deDescription: 'DWG / DOC'
    }).subscribe((res: IProjectElementDetailsOutput[]) => {
      res.forEach(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);
      this.dwgList = res;
    });

    this._projInfoService.getProjectElementDetails({
      projectId: this.projectId,
      groupId: this.groupId,
      moduleId: Module.ScheduleDocument,
      deDescription: 'Discipline'
    }).subscribe((res: IProjectElementDetailsOutput[]) => {
      res.forEach(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);
      this.discipline = res;
    });

    this._projInfoService.getProjectElementDetails({
      projectId: this.projectId,
      groupId: this.groupId,
      moduleId: Module.ScheduleDocument,
      deDescription: 'Structure / Package'
    }).subscribe((res: IProjectElementDetailsOutput[]) => {
      res.map(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);
      this.structure = res;
    });

    this._scheDefService.getDocSetList({
      project_Id: this.projectId,
      group_Id: this.groupId
    }).subscribe((res: IDocSetModel[]) => {
      this.docSetList = res;
    });
  }

  getClass() {
    if (this.requiredField["btn-stylee-required"]) {
      return 'my_class1'
    } else {
      return 'my_class2'
    }
  }

  selectedDwg(value: any) {
    if (value.value != "-2") {
      this.drg_Type = value.additionalValues.additionalValues.dedId.toString();
    } else {
      this.drg_Type = null;
    }
  }

  getFromDateValue(date: any) {
    this.from_Date = date;
  }

  getToDateValue(date: any) {
    this.to_Date = date;
  }

  selectedStage(value: any) {
    if (value.value != "-2") {
      this.stages = value.additionalValues.additionalValues.dedId;
    } else {
      this.stages = null;
    }
  }

  selectedScheduleType(value: any) {
    let docdata
    if (value && value.emittingList)
      docdata = value.emittingList.map((x: {
        value: any;
      }) => +x.value);

    if (docdata && docdata.length > 0)
      this.Doc_typeid = docdata;
    else
      this.Doc_typeid = null;
  }

  selectedDiscipline(value: any) {
    if (value.value != "-2") {
      this.disciplineId = value.additionalValues.additionalValues.dedId.toString();
    } else {
      this.disciplineId = null;

    }
  }

  selectedSturcture(value: any) {
    if (value.value != "-2") {
      this.structureId = value.additionalValues.additionalValues.dedId.toString();
    } else {
      this.structureId = null;

    }
  }

  valueChanged() {
    switch (this.inputFields) {
      case 'final_drawing':
        this.finalDrawingFilterInputEmit();
        break;
      case 'pending_drawing_status':
        this.pendingDrawingFilterInputEmit();
        break;
      case 'respond_workflow':
        this.respondWorkFlowInputEmit();
        break;
      case 'search_dci':
        this.SearchDCI_InputEmit();
        break;
    }
  }

  SearchDCI_InputEmit() {
    this.LoadSearchDetails().then((res: any[]) => {
      let obj: any = {
        "project_Id": this.projectId,
        "group_Id": this.memberLinkedGroupID,
        "from_Date": this.from_Date,
        "to_Date": this.to_Date,
        "stages": this.stages,
        "schedule_Type": (!!this.Doc_typeid && this.Doc_typeid.length > 0) ? this.Doc_typeid.toString() : null,
        "drg_Type": this.drg_Type,
        "disc_Id": this.disciplineId,
        "struct_Id": this.structureId,
        "transmittal_no": this.transmittal_no,
        "docset_id": this.docset_id,
        "doc_no": this.doc_no,
        Dynamic_Id: res,
      }
      this.valueChange.emit(obj);
    })
  }

  finalDrawingFilterInputEmit() {
    this.LoadSearchDetails().then((res: any[]) => {
      let obj = {
        "project_Id": this.projectId,
        "group_Id": this.memberLinkedGroupID,
        "from_Date": this.from_Date,
        "to_Date": this.to_Date,
        "stages": this.stages,
        "schedule_Type": (!!this.Doc_typeid && this.Doc_typeid.length > 0) ? this.Doc_typeid.toString() : null,
        "drg_Type": this.drg_Type,
        "disc_Id": this.disciplineId,
        "struct_Id": this.structureId,
        Dynamic_Id: res,
      }
      this.valueChange.emit(obj);
    })
  }

  pendingDrawingFilterInputEmit() {
    this.LoadSearchDetails().then((res: any[]) => {
      let obj = {
        "project_Id": this.projectId,
        "group_Id": this.memberLinkedGroupID,
        "from_Date": this.from_Date,
        "to_Date": this.to_Date,
        "stages": this.stages,
        "schedule_Type": (!!this.Doc_typeid && this.Doc_typeid.length > 0) ? this.Doc_typeid.toString() : null,
        "drg_Type": this.drg_Type,
        "disc_Id": this.disciplineId,
        "struct_Id": this.structureId,
        Dynamic_Id: res,
      }
      this.valueChange.emit(obj);
    })
  }

  ScheduleTypeParamCreation(is_dci = false): any {
    let schedule_Type: any[] = [];
    if (this.DCI_Type.get('dci_dwg')?.value == true) {
      schedule_Type.push(1);
    }
    if (this.DCI_Type.get('ext_dci')?.value == true) {
      schedule_Type.push(2);
    }
    if (this.DCI_Type.get('std_drawing')?.value == true) {
      schedule_Type.push(4);
    }
    if (this.DCI_Type.get('ven_dwg')?.value == true) {
      schedule_Type.push(3);
    }
    let schedule_TypeIdConvert: any = schedule_Type.toString();
    if (!schedule_TypeIdConvert) {
      schedule_TypeIdConvert = null;
    }
    if (is_dci && schedule_Type.length > 0)
      return schedule_Type
    else
      return schedule_TypeIdConvert
  }

  respondWorkFlowInputEmit() {
    this.LoadSearchDetails().then((res: any[]) => {
      let obj = {
        "disc_Id": this.disciplineId,
        "struct_Id": this.structureId,
        "dwgID": this.drg_Type,
        "workflowId": this.stages,
        "from_Date": this.from_Date,
        "to_Date": this.to_Date,
        "Doc_typeid": this.Doc_typeid,
        Dynamic_Id: res,
      }
      this.valueChange.emit(obj);
    })
  }

  SelectedDocSet(value: any) {
    if (value.value != "-2") {
      this.docset_id = value.additionalValues.additionalValues.doc_Set_Id;
    }
  }

  async getDynamicForm() {
    this._projInfoService.getProjectElements({
      projectId: this.projectId,
      groupId: this.groupId,
      moduleId: Module.ScheduleDocument,
      IsQueryForStaticElement: false
    }).subscribe(
      (res: IProjectElementsOutput[]) => {
        this.projectElements = res;

        this.elementsConfig = res.filter(s => {
          return s.isMandatory == true;
        }).map(x => {
          let field: FieldConfig;
          let childDEId = null;
          let childDEDescription = "";
          let data = res.filter(item => item.dependentElementId == x.elementId);

          if (data.length > 0) {
            childDEId = data[0].elementId;
            childDEDescription = data[0].elementDescription;
          }

          field = {
            de_id: x.elementId,
            module_id: Module.ScheduleDocument,
            dependent_de_id: x.dependentElementId,
            dependent_de_Description: x.dependentElementDescription,
            child_de_id: childDEId,
            child_de_Description: childDEDescription,
            name: x.elementDescription,
            deDescription: x.elementDescription,
            type: 'select',
            value: new BehaviorSubject(null)
          };

          return field;
        });
        this.dynamicForm.fields = this.elementsConfig;
        this.dynamicForm.createControl();
        this.onCascadingAutocomplete_Change();
        this.copyElementDetailsFromSource();
      });
  }

  onCascadingAutocomplete_Change() {
    this.elementsConfig.forEach((data: any) => {
      if (!!data.child_de_id) {
        this.dynamicForm.form.get(data.deDescription)?.valueChanges.subscribe(x => {
          let resForm: FormGroup = this.dynamicForm.value;
          let _field = this.dynamicForm.getCascadingAutocompleteDetails(data.child_de_Description);
          let parentControlSelectedValue: IProjectElementDetailsOutput = resForm.get(data.deDescription)?.value;

          if (_field.length > 0 && !!parentControlSelectedValue) {
            this._projInfoService.getProjectElementCascadingDetails({
              projectId: this.projectId,
              groupId: this.groupId,
              moduleId: Module.ScheduleDocument,
              deId: _field[0].de_id,
              deDescription: _field[0].deDescription,
              dependentDEId: _field[0].dependent_de_id,
              dependentDEDId: parentControlSelectedValue.dedId
            }).subscribe((res: IProjectElementDetailsOutput[]) => {
              if (res.length > 0) {
                res.map(val => val.displayText = (val.dedShortDescription!! && val.dedShortDescription.trim().length > 0 ? (val.dedShortDescription + " - ") : "") + val.dedDescription);
                _field[0].values = res;
              } else {
                _field[0].values = [];
              }
            }, err => { });
          } else {
            _field[0].values = [];
          }
        })
      }
    })
  }

  private copyElementDetailsFromSource() {
    let sourceProjElementForm: FormGroup = this.dynamicForm.value;
    this.projectElements.filter(s => {
      return s.isNumbering == false
    }).forEach(x => {
      let selectedValue: IProjectElementDetailsOutput = sourceProjElementForm.get(x.elementDescription)?.value;
      if (!!selectedValue) {
        let field: FieldConfig | undefined = this.elementsConfig.find(ele => ele.de_id == selectedValue.deId && ele.deDescription == selectedValue.deDescription);
        if (field && field.value) {
          field.value.next(selectedValue.dedId);
        }
      }
    })
  }

  async LoadSearchDetails(): Promise<any[]> {
    let resForm: FormGroup | undefined | null = this.dynamicForm.form;
    let FilterDetails: any[] = [];

    this.projectElements.map(async x => {
      let result: any;
      let selectedValue: IProjectElementDetailsOutput = resForm.get(x.elementDescription)?.value;
      result = {
        dE_Id: x.elementId,
        dED_Id: selectedValue.dedId
      }
      FilterDetails.push(result);
    })

    return FilterDetails;
  }
}